import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";

export async function getPrices({ commit, state }, paginate=true) {

    let params = state.params
    params.paginate = paginate ? 1 : null

  await $http
    .get("/api/price", { params })
    .then(res => {
        if (paginate){
            commit("setPrices", res.data.data);
        }else{
            commit("setPricesExcel", res.data.data);
        }

    })
    .catch(error => {
      Notification.error({
        title: "¡Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("priceError", error.message);
    });
}

export async function updatedPrice({ commit, state }) {
  await $http
    .put(`/api/price-update`, state.paramsUpdatePrices)
    .then(res => {
      Notification.success({
        title: "Hecho!",
        message: "Se Ha actualizado el precio",
        type: "success",
        duration: 2000,
        customClass: "notification-box"
      });
    })
    .catch(error => {
      Notification.error({
        title: "¡Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}
export async function updatedPriceExcel({ state }, data) {
  await $http
    .put(`/api/price-update-excel`, data)
    .then(res => {
      Notification.success({
        title: "Hecho!",
        message: "Se ha cargado la informacion correctamente.",
        type: "success",
        duration: 2000,
        customClass: "notification-box"
      });
    })
    .catch(error => {
      Notification.error({
        title: "¡Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}
export async function uploadExcel({ commit, state }, excel) {
  await $http
    .post("/api/import-excel", excel)
    .then(res => {})
    .catch(error => {
      Notification.error({
        title: "¡Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("updatePriceError", error.message);
    });
}

//Obtener las sedes
export async function fetchBranchOffices({ commit, state }) {
  await $http
    .get("/api/sedes")
    .then(response => {
      commit("setBranchOffices", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function fetchBrand({ dispatch, state, rootState, commit }) {
  await dispatch(
    "brands/fetchBrands",
    { params: { paginate: false, lines: state.params.lines } },
    { root: true }
  );
  commit("setBrands", rootState.brands.brands);
}

export async function fetchList({ commit }) {
  await $http
    .get("/api/parametros-por-tabla/14")
    .then(response => {
      commit("setList", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function fetchLines({ dispatch, state, rootState, commit }) {
  await dispatch(
    "lines/fetchLines",
    { params: { paginate: false } },
    { root: true }
  );
  commit("setLines", rootState.lines.lines);
}

export async function uploadFilePrice({ commit }, data) {
  await $http
    .post("/api/price-format-excel", data)
    .then(response => {
        commit("setPrices", response.data);
    }).catch(async error => {
          const message = error.response.data.message ? error.response.data.message : 'Internal Server Error';
          MessageBox.alert(message, 'Error', {
              confirmButtonText: 'Aceptar',
              type: 'error',
              customClass: 'notification-error',
          });
      });
}

export async function getAuditListPrice({ commit, state },id_price_list) {
  await $http
    .get("/api/auditoria-lista-precio/"+id_price_list)
    .then(response => {
      commit("setAudit", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}




// WEBPACK FOOTER //
// ./src/modules/prices/actions.js